var loadVelt = function (callback, version, staging, develop, proxyDomain) {
    if (version === void 0) { version = 'latest'; }
    if (staging === void 0) { staging = false; }
    if (develop === void 0) { develop = false; }
    var existingScript = document.getElementById('veltScript');
    if (!existingScript) {
        var script = document.createElement('script');
        if (staging) {
            script.src = "https://us-central1-snipply-sdk-staging.cloudfunctions.net/getprivatenpmpackagefile?packageName=sdk-staging&packageVersion=".concat((!version || version === 'latest') ? '1.0.1' : version, "&filePath=velt.js&orgName=@veltdev");
        }
        else if (develop) {
            script.src = "https://us-central1-snipply-sdk-staging.cloudfunctions.net/getprivatenpmpackagefile?packageName=sdk-dev&packageVersion=".concat((!version || version === 'latest') ? '1.0.1' : version, "&filePath=velt.js&orgName=@veltdev");
        }
        else {
            if (proxyDomain) {
                // remove trailing slash from proxy
                if (proxyDomain[proxyDomain.length - 1] === '/') {
                    proxyDomain = proxyDomain.slice(0, -1);
                }
                script.src = "".concat(proxyDomain, "/lib/sdk@").concat(version, "/velt.js");
            }
            else {
                script.src = "https://cdn.velt.dev/lib/sdk@".concat(version, "/velt.js");
            }
        }
        script.id = 'veltScript';
        script.type = 'module';
        document.body.appendChild(script);
        script.onload = function () {
            if (callback) {
                callback();
            }
        };
    }
    else {
        if (callback) {
            callback();
        }
    }
};
export default loadVelt;
